import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE_URL = "https://ghrianghraffy.com";

const fetchUserProfile = async (token) => {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.get(`${API_BASE_URL}/auth/profile`, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

const ParentProfile = () => {
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const data = await fetchUserProfile(token);
        setProfile(data);
      } catch (err) {
        setError("Failed to load profile");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div>
      <h1>Parent Profile</h1>
      <p>Email: {profile.email}</p>
      <p>Role: {profile.role}</p>
      <p>School: {profile.school_name || "No school assigned"}</p>
      <p>Total Photos: {profile.total_photos}</p>
    </div>
  );
};

export default ParentProfile;
